export enum UserCivility {
  Mr = "Mr",
  Mrs = "Mrs"
}

export enum DealerType {
  PERSONAL = "PERSONAL",
  PROFESSIONAL = "PROFESSIONAL"
}

export enum BusinessType {
  FREELANCE = "FREELANCE", 
  PRIVATE_LIMITED = "PRIVATE LIMITED", 
  PUBLIC = "PUBLIC"
}

export enum DealerStatus {
  AWAITING_VERIFICATION = "AWAITING_VERIFICATION",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED"
}

export enum ReviewStatus  {
  TO_CHECK = "TO_CHECK",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED"
};

export enum MobileMoneyOperator  {
  MTN = "MTN",
  ORANGE = "ORANGE"
};

export enum PaymentTermOption  {
  PAY_NOW = "PAY_NOW",
  PAY_ADVANCE = "PAY_ADVANCE",
  PAY_LATER = "PAY_LATER"
};


export enum ContractStatus  {
  DRAFT = "DRAFT",
  PROPOSED = "PROPOSED",
  ACCEPTED = "ACCEPTED",
  REFUSED = "REFUSED",
  SUSPENDED = "SUSPENDED",
  CLOSED = "CLOSED",
};

export enum ContractType  {
  MANAGEMENT = "MANAGEMENT",
  PROVIDER = "PROVIDER"
};

export enum ContractModificationType  {
  CONTRACT_PROPOSE = "CONTRACT_PROPOSE",
  REQUEST_WITHDRAW = "REQUEST_WITHDRAW",
  CONTRACT_UPDATE = "CONTRACT_UPDATE",
  CAR_ADD = "CAR_ADD",
  CAR_UPDATE = "CAR_UPDATE",
  CAR_SUSPEND = "CAR_SUSPEND",
  CAR_CLOSE = "CAR_CLOSE",
  CONTRACT_SUSPEND = "CONTRACT_SUSPEND",
  CONTRACT_CLOSE = "CONTRACT_CLOSE"
};

export enum ContractBusinessLine  {
  RENT = "RENT",
  SELL = "SELL",
  KEEP = "KEEP"
};

export enum ContractModificationStatus  {
  PROPOSED = "PROPOSED",
  ACCEPTED = "ACCEPTED",
  WITHDRAWN = "WITHDRAWN",
  REFUSED = "REFUSED",
};

export enum ContractLineStatus  {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  CLOSED = "CLOSED"
};

export enum NotificationType {
  PUSH = "PUSH",
  PULL = "PULL"
};

export enum NotificationObjectType {
  CUSTOMER = "CUSTOMER",
  PROVIDER = "PROVIDER",
  OWNER = "OWNER",
  CAR = "CAR",
  BUY = "BUY",
  RENT = "RENT"
};

export class DealerBasicData {
    public static civilities = [UserCivility.Mr, UserCivility.Mrs];
    public static dealerTypes = [DealerType.PERSONAL, DealerType.PROFESSIONAL];
    public static businessTypes = [BusinessType.FREELANCE, BusinessType.PRIVATE_LIMITED, BusinessType.PUBLIC];

    public static mobileMoneyOperators: any = [
      {
        code: MobileMoneyOperator.MTN,
        desc: "MTN"
      },
      {
        code: MobileMoneyOperator.ORANGE,
        desc: "Orange"
      }
    ];


    public static paymentTermOptions: any = [
      {
        code: PaymentTermOption.PAY_NOW,
        title: "Payer maintenant",
        details: "Payer immédiatement et bénéficier d'une réduction de 15%"
      },
      {
        code: PaymentTermOption.PAY_ADVANCE,
        title: "Payer une avance",
        details: "Payez une avance pour confirmer votre réservation"
      },
      {
        code: PaymentTermOption.PAY_LATER,
        title: "Payer plus tard",
        details: "Réservez et payez sur place. Attention, votre place n'est pas garantie."
      }
    ];

    public static contractTypes: any = [
      {
        code: ContractType.MANAGEMENT,
        desc: "Gestion"
      },
      {
        code: ContractType.PROVIDER,
        desc: "Fournisseur"
      }
    ];

    public static contractBusinessLines: any = [
      
      {
        code: ContractBusinessLine.SELL,
        desc: "Vendre"
      },
      {
        code: ContractBusinessLine.RENT,
        desc: "Louer"
      },
      {
        code: ContractBusinessLine.KEEP,
        desc: "Maintenir"
      }
    ];
  
  }